import { render, staticRenderFns } from "./fireFightingLegalCheckDetail.vue?vue&type=template&id=17bca81d"
import script from "./fireFightingLegalCheckDetail.vue?vue&type=script&lang=js"
export * from "./fireFightingLegalCheckDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17bca81d')) {
      api.createRecord('17bca81d', component.options)
    } else {
      api.reload('17bca81d', component.options)
    }
    module.hot.accept("./fireFightingLegalCheckDetail.vue?vue&type=template&id=17bca81d", function () {
      api.rerender('17bca81d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/legal/fireFightingLegalCheckDetail.vue"
export default component.exports